import types from '@/vuex/arquivos-assinados/actions-types'
import documentos from '@/utils/documentos'

const actions = {
  [types.SET_LISTA_ARQUIVOS_ASSINADOS]: ({ commit }, payload) => commit(types.SET_LISTA_ARQUIVOS_ASSINADOS, payload),
  [types.SET_LISTA_TIPOS_ASSINATURA]: ({ commit }, payload) => commit(types.SET_LISTA_TIPOS_ASSINATURA, payload),
  [types.BUSCAR_ARQUIVOS_ASSINADOS]: async ({ commit }, payload) => {
    try {
      commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando Arquivos Assinados' }, {root: true})
      const response = await documentos.buscarArquivosAssinadosVinculados(
          payload.vinculados,
          payload.usuarioAssinante,
          payload.dataAssinaturaInicio,
          payload.dataAssinaturaFim,
          payload.arquivosAssinadosUsuario)
      if (response.data.length === 50) {
        commit(types.SHOW_SNACKBAR, {
          snackbarType: 'warning',
          snackbarText: 'Limite de busca de 50 arquivos atingido. Favor filtrar melhor a busca caso o arquivo buscado não estiver nos resultados'
        }, {root: true})
      }
      commit(types.SET_LISTA_ARQUIVOS_ASSINADOS, { listaArquivosAssinados: response.data })
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível buscar os arquivos assinados' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando Arquivos Assinados' }, {root: true})
    }
  },
  [types.BUSCAR_TIPOS_ASSINATURA]: async ({ commit }) => {
    try {
      commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando Tipos de Assinatura' }, {root: true})
      const response = await documentos.buscarTiposAssinatura()
      commit(types.SET_LISTA_TIPOS_ASSINATURA, { listaTiposAssinatura: response.data })
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível buscar os tipos de assinatura' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando Tipos de Assinatura' }, {root: true})
    }
  },
  [types.GET_ARQUIVO_ASSINADO_BLOB_URL]: async ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Carregando arquivo' }, {root: true})
    commit(types.SET_ARQUIVO_ASSINADO_BLOB_URL, {arquivoAssinadoBlobURL: null})
    try {
      const response = await documentos.buscarArquivoAssinado(payload.idArquivoAssinado, payload.tipoArquivo)
      const blob = new Blob([response.body], {type: 'application/pdf'})
      const blobURL = (window.URL || window.webkitURL).createObjectURL(blob)
      commit(types.SET_ARQUIVO_ASSINADO_BLOB_URL, {arquivoAssinadoBlobURL: blobURL})
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível abrir o arquivo' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Abrindo arquivo' }, {root: true})
    }
  },
  [types.EXCLUIR_ARQUIVO_ASSINADO]: async ({ commit, dispatch }, payload) => {
    const confirmacaoCallback = async () => {
      try {
        commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: `Excluindo arquivo assinado ${payload.arquivoAssinado.nomeOriginal}` }, {root: true})
        await documentos.excluirArquivoAssinado(payload.arquivoAssinado.idArquivoAssinado)
        payload.listaArquivosAssinados.splice(payload.listaArquivosAssinados.findIndex(function (i) {
          return i.idArquivoAssinado === payload.arquivoAssinado.idArquivoAssinado
        }), 1)
        commit(types.SET_LISTA_ARQUIVOS_ASSINADOS, { listaArquivosAssinados: payload.listaArquivosAssinados })
        commit(types.SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: `${payload.arquivoAssinado.nomeOriginal} excluído com sucesso` }, {root: true})
        return true
      } catch (error) {
        commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: `Não foi possível excluir ${payload.arquivoAssinado.nomeOriginal}` }, {root: true})
        return false
      } finally {
        commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: `Excluindo arquivo assinado ${payload.arquivoAssinado.nomeOriginal}` }, {root: true})
      }
    }
    const config = {
      textoPergunta: 'Excluir o arquivo assinado?',
      textoConteudo: `O arquivo assinado "${payload.arquivoAssinado.nomeOriginal}" será excluído da lista de arquivos assinados.`,
      textoNao: 'Cancelar',
      textoSim: 'Excluir',
      confirmacaoCallback: confirmacaoCallback
    }
    commit(types.SHOW_CONFIRMATION_DIALOG, { ...config }, {root: true})
  },
  async [types.EXCLUIR_ARQUIVO_ASSINADO_EM_BLOCO] ({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      const confirmacaoCallback = async () => {
        commit(types.SHOW_GLOBAL_LOADING, {globalLoadingTitle: `Excluindo arquivos assinados`}, {root: true})
        for (const arquivo of payload.listaArquivosSelecionados) {
          try {
            await documentos.excluirArquivoAssinado(arquivo.idArquivoAssinado)
            payload.listaArquivosAssinados.splice(payload.listaArquivosAssinados.findIndex(function (i) {
              return i.idArquivoAssinado === arquivo.idArquivoAssinado
            }), 1)
          } catch (error) {
            commit(types.SHOW_SNACKBAR, {
              snackbarType: 'error',
              snackbarText: `Não foi possível excluir ${arquivo.nomeOriginal}. Erro: ${error.body.message}`
            }, {root: true})
            commit(types.HIDE_GLOBAL_LOADING, {globalLoadingTitle: `Excluindo arquivos assinados`}, {root: true})
            reject(error.body.message)
            return
          }
        }
        commit(types.HIDE_GLOBAL_LOADING, {globalLoadingTitle: `Excluindo arquivos assinados`}, {root: true})
        commit(types.SET_LISTA_ARQUIVOS_ASSINADOS, { listaArquivosAssinados: payload.listaArquivosAssinados })
        commit(types.SHOW_SNACKBAR, {
          snackbarType: 'success',
          snackbarText: `Arquivos selecionados excluídos com sucesso`
        }, {root: true})
        resolve(true)
        return
      }
      const config = {
        textoPergunta: 'Excluir os arquivos assinados selecionados?',
        textoConteudo: `Os arquivo assinados selecionados serão excluídos da lista de arquivos assinados.`,
        textoNao: 'Cancelar',
        textoSim: 'Excluir',
        confirmacaoCallback: confirmacaoCallback
      }
      commit(types.SHOW_CONFIRMATION_DIALOG, { ...config }, {root: true})
    })
  },
  [types.INSERIR_ARQUIVO_ASSINADO]: async ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: `Assinando arquivo ${payload.body.get('arquivo').name}` }, {root: true})
    try {
      await documentos.inserirArquivoAssinado(payload.body, payload.idTipoAssinatura, payload.tipoAssinatura, payload.matrSiape)
      commit(types.SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: `Arquivo ${payload.body.get('arquivo').name} assinado com sucesso` }, {root: true})
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: `Arquivo ${payload.body.get('arquivo').name} não assinado: ${error.body.message}` }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: `Assinando arquivo ${payload.body.get('arquivo').name}` }, {root: true})
    }
  },
  [types.SHOW_INSERCAO_ARQUIVO_ASSINADO_DIALOG]: async ({ commit }) => {
    commit(types.SHOW_INSERCAO_ARQUIVO_ASSINADO_DIALOG)
  },
  [types.HIDE_INSERCAO_ARQUIVO_ASSINADO_DIALOG]: async ({ commit }) => {
    commit(types.HIDE_INSERCAO_ARQUIVO_ASSINADO_DIALOG)
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/vuex/arquivos-assinados/actions.js